import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 245.1 230.66"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M230.77,230.66H14.32c-4.71,0-8.97-2.21-11.69-6.06-2.72-3.84-3.37-8.59-1.79-13.03l40.26-113.35c.47-1.33,1.93-2.02,3.26-1.55,1.33.47,2.02,1.93,1.55,3.26L5.65,213.29c-1.01,2.85-.59,5.91,1.15,8.38,1.75,2.48,4.49,3.9,7.52,3.9h216.45c3.03,0,5.77-1.42,7.52-3.9,1.75-2.47,2.17-5.53,1.15-8.38l-40.26-113.35c-.47-1.33.22-2.78,1.55-3.26,1.33-.47,2.78.22,3.26,1.55l40.26,113.35c1.58,4.44.92,9.18-1.79,13.03-2.72,3.85-6.98,6.05-11.69,6.05Z" />
        <path d="M122.55,169.81c-13.86,0-31.95-18.5-44.26-35.8-16.06-22.58-25.64-46.54-25.64-64.11C52.65,31.36,84,0,122.55,0s69.9,31.36,69.9,69.9c0,17.56-9.59,41.53-25.64,64.11-12.31,17.31-30.4,35.8-44.26,35.8ZM122.55,5.1c-35.73,0-64.8,29.07-64.8,64.8s43.61,94.81,64.8,94.81,64.8-58.57,64.8-94.81S158.28,5.1,122.55,5.1Z" />
        <path d="M151.94,107.99h-58.78c-2.55,0-4.62-2.07-4.62-4.62v-43.22h-6.72c-1.49,0-2.81-.94-3.3-2.35-.48-1.4-.02-2.96,1.14-3.88l40.12-31.47c1.63-1.28,3.9-1.28,5.53,0l11.36,8.91v-2.21c0-2.47,2.01-4.48,4.48-4.48h6.82c2.47,0,4.48,2.01,4.48,4.48v14.59l12.98,10.18c1.17.92,1.63,2.48,1.14,3.88-.49,1.4-1.81,2.35-3.3,2.35h-6.72v43.22c0,2.55-2.07,4.62-4.62,4.62ZM93.63,102.89h57.82v-45.3c0-1.41,1.14-2.55,2.55-2.55h4.6l-10.28-8.06c-.62-.48-.98-1.22-.98-2.01v-15.21h-5.58v6.83c0,.98-.56,1.87-1.43,2.29-.88.43-1.92.32-2.69-.29l-15.1-11.85-36.06,28.29h4.6c1.41,0,2.55,1.14,2.55,2.55v45.3ZM122.16,26.45s0,0,0,0c0,0,0,0,0,0Z" />
      </g>
    </svg>
  )
}

export default Icon
